var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_72067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.715429 16.4038L17.677 9.48074C17.8723 9.40101 18 9.21099 18 9.00001C18 8.78904 17.8723 8.59902 17.677 8.51929L0.715429 1.59621C0.506847 1.51106 0.267153 1.57016 0.122028 1.7425C-0.0229912 1.91483 -0.0405007 2.16103 0.0788898 2.35214L4.23383 9.00001L0.0789255 15.6479C0.0260156 15.7325 -6.23772e-07 15.8279 -6.27927e-07 15.923C-6.33154e-07 16.0425 0.0412019 16.1616 0.122062 16.2575C0.26715 16.4299 0.506883 16.489 0.715429 16.4038Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_72067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadReply);
export default __webpack_public_path__ + "static/media/thread-reply.8814ce580bd9f8dfffd7e3be2ab76f78.svg";
export { ForwardRef as ReactComponent };